module.exports = __webpack_public_path__ + "static/media/rectangle-11.62f7f9cd.svg";